import React, { createContext, useMemo, useState } from "react";

export type LayoutTypeName = "app" | "plain" | "none";

export interface LayoutTypeContext {
  layoutType: LayoutTypeName;
  setLayoutType: (layoutName: LayoutTypeName) => void;
}

export const LayoutContext = createContext<LayoutTypeContext>({
  layoutType: "app",
  setLayoutType: () => undefined
});

const LayoutProvider: React.FC = ({ children }) => {
  const [layoutType, setLayoutType] = useState<LayoutTypeName>("app");
  const contextValue = useMemo(
    () => ({
      layoutType,
      setLayoutType
    }),
    [layoutType]
  );

  return (
    <LayoutContext.Provider value={contextValue}>
      {children}
    </LayoutContext.Provider>
  );
};

export default LayoutProvider;
